import React, {  useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate, } from 'react-router-dom';
import { SuccessfullyModal } from '../../components/Modals/Modals'
import { postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

const AddTermsConditions = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [termsDetails, setTermsDetails] = useState('');
    const termsTitle = 'Terms Conditions'




    const handleSubmit = async () => {
        const payload = {
            title: termsTitle,
            description: termsDetails,
        };

        await postApi(endPoints.addterms, payload, {
            setLoading,
            successMsg: 'Terms & Conditions added successfully!',
            errorMsg: 'Failed to add terms & conditions!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/termsconditions'); // Redirect to the Privacy Policy list page
        }, 2000);
    };
    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text="Successfully Added"
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Add Terms & Conditions</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
                            <p>View Terms & Conditions</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Terms & Conditions Details</h6>
                        </div>
                        <div className={addjob.editprivacypolicy}>
                            <label htmlFor="policyDetails">Add Terms & Conditions Details*</label>
                            <textarea
                                id="policyDetails"
                                placeholder="Add the policy details here..."
                                value={termsDetails}
                                onChange={(e) => setTermsDetails(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button
                                onClick={handleSubmit}
                                style={{ background: '#F05423' }}
                                disabled={loading || !termsDetails.trim()}
                            >
                                {loading ? "Adding..." : "Add"}
                            </button>
                        </div>
                    </div>

                </div>

            </div >
        </>
    )
}

export default HOC(AddTermsConditions)